export default __webpack_public_path__ + "static/Experienced-3823a9b59b50356f3dbec6fd2f121fe5.webp";